import { render, staticRenderFns } from "./HrSalaryInsInjury.vue?vue&type=template&id=afb51950&scoped=true&"
import script from "./HrSalaryInsInjury.vue?vue&type=script&lang=js&"
export * from "./HrSalaryInsInjury.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb51950",
  null
  
)

export default component.exports